export const config = {
  pagination: false,
  tableType: 'antd',
  columns: [
    {
      title: '分类名称',
      dataIndex: 'cateName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    { title: '所属产品库', dataIndex: 'productLibraryName', width: 160, ellipsis: true },
    // { title: '关联施工SKU', dataIndex: 'relationSpu', width: 200, render: 'skuNameRender' },
    { title: '特项代码', dataIndex: 'specialCode', width: 160, ellipsis: true },
    { title: '创建人', dataIndex: 'createdByName', width: 160, ellipsis: true },
    { title: '创建时间', dataIndex: 'createdTime', width: 180, itemType: 'dateTime' },
    { title: '状态', dataIndex: 'enabled', width: 90,fixed: 'right', render: 'switchRender' },
    { title: '操作', dataIndex: '#', width: 180, fixed: 'right', render: 'actionRender' },
  ],
  search: [
    {
      name: 'cateNameKeyword',
      label: '分类名称',
    },
  ],
  footer: [
    {
      label: '下载导入模板',
      render: 'exportRender',
    },
    {
      label: '批量导入',
      render: 'importRender',
    },
    {
      label: '新增',
      render: 'addRender',
    },
  ],
  batchActions: [
    {
      label: '所属产品库',
      events: ['onClick:onChangeProductLibrary'],
    },
    /*{
      label: '关联施工',
      events: ['onClick:onRelatedConstruction'],
    },*/
  ],
}
